module.exports = __webpack_public_path__ + "static/media/aria_thumb.6a3647cd.webp";